import { Handle, Position } from "@xyflow/react";
import React from "react";
import { AssetStatus } from "../../types/statusTypes";
import Button from "../Button";

interface NodeProps {
  data: {
    id: string;
    label: string;
    assetStatus: AssetStatus;
    restartAllowed: boolean;
  };
}

export default function Node({ data: { id, label, assetStatus, restartAllowed } }: NodeProps) {
  return (
    <>
      <Button
        className="react-flow__label__txt"
        type="button"
        data-bs-toggle="modal"
        data-bs-target={assetStatus === AssetStatus.Active ? "#restart-modal" : "#revoke-modal"}
        data-job-id={id}
        data-restart-allowed={restartAllowed}
        text={label}
      />
      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Left} />
    </>
  );
}
